"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const leaflet_1 = __importDefault(require("leaflet"));
const tiles_1 = require("../helpers/tiles");
class SetMapTiles {
    constructor(container, map) {
        this.container = container;
        this.map = map;
        this.set();
    }
    set() {
        const tiles = (0, tiles_1.getTiles)(this.container);
        leaflet_1.default.tileLayer((tiles === null || tiles === void 0 ? void 0 : tiles.url) ? tiles.url : 'https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
        }).addTo(this.map);
        leaflet_1.default.control.attribution({
            position: 'topleft',
        }).setPrefix(false).addAttribution((tiles === null || tiles === void 0 ? void 0 : tiles.attribution)
            ? tiles.attribution
            : '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>').addTo(this.map);
    }
}
exports.default = SetMapTiles;
